import FAQ from '@/views/faq'
import ListFAQ from '@/views/faq/list'
import CreateFAQ from '@/views/faq/create'
import EditFAQ from '@/views/faq/edit'
import DetailFAQ from '@/views/faq/detail'

export default {
  path: 'forum',
  component: FAQ,
  redirect: 'forum/list',
  name: 'FAQ',
  children: [
    {
      path: 'list',
      name: 'forum.forum',
      component: ListFAQ
    },
    {
      path: 'create',
      name: 'forum.create',
      component: CreateFAQ
    },
    {
      path: ':faq_id/edit',
      name: 'forum.update',
      component: EditFAQ
    },
    {
      path: ':faq_id/detail',
      name: 'forum.attribute.topic',
      component: DetailFAQ
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/faqs/faq.js